import { IDatasource, IDatasourceReportFn } from 'core-ts-types';

export interface ICancellationReasons {
  id: number;
  name: string;
}

export interface ICancellationReasonsDatasource {
  cancellationReasons: ICancellationReasons[];
  countAsNoShow: boolean;
}

export class CancellationReasonsDatasource implements IDatasource {
  private _source: ICancellationReasonsDatasource;

  constructor() {
    this.initialize();
  }

  initialize(): CancellationReasonsDatasource {
    this._source = {
      cancellationReasons: [],
      countAsNoShow: false
    };
    return this;
  }

  write(raw: any): CancellationReasonsDatasource {
    this._source = {
      cancellationReasons: _.sortBy(raw, 'name'),
      countAsNoShow: false
    };
    return this;
  }

  read(): ICancellationReasonsDatasource {
    return this._source;
  }

  clear(): void {
    this.initialize();
  }

  report(fn: IDatasourceReportFn): any[] {
    return fn(this._source);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/datasources/cancellation_reasons_datasource.ts